// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/lifeline/line-point.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lifeline{  
    /*background-color: #f9f9f9;*/
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 46px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
}

.Lifeline_form{
    display: flex;
    flex-direction: column;
    height: 100%;
}

.Lifeline_header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.Lifeline_header_actions{
    display: flex;
    align-items: center;
    gap: 16px;
}

.Lifeline_title{
    font-weight: 600;
    font-size: calc(20px * var(--fontScaler));
    line-height: 27px;

    color: #000000;
}

.Lifeline_main{
    flex: 1;
    overflow: hidden;
}

.Lifeline_events_container{
    height: 100%;
    overflow: hidden;
    position: relative;
}

.Lifeline_events_wrapper{
    position: relative;
    min-height: 100%;
}

.Lifeline_timeline_background{
    position: absolute;
    right: 28px;
    top: 0;
    bottom: 0;
    min-height: 100%;
    width: 57px;
    background-size: 17px 20px;
    background-position: right top;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: repeat-y;
    pointer-events: none;
    z-index: 0;
}

.Lifeline_events{
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 20px;
    padding-top: 20px;
    margin-left: 16px;
    position: relative;
    z-index: 1;
}

/**/
.Lifeline_item{
    display: flex;
    gap: 12px;
}

.Lifeline_item_sizer{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.Lifeline_item_sizer--negative{
    align-items: flex-end;
}

.Lifeline_dots{
    width: 57px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 20px;
}

.Lifeline_age{
    font-weight: 600;
    font-size: calc(12px * var(--fontScaler));
    line-height: 16px;
    color: #000000;
    background: #f9f9f6;
    padding: 2px 6px;
    border-radius: 8px;
    border: none;
    position: relative;
    z-index: 1;
    white-space: nowrap;
}

.Lifeline_empty{
    text-align: center;
    color: #8E9ABB;
    padding: 20px;
    font-style: italic;
}

.error{
    color: #E23424;
    text-align: center;
    padding: 20px;
}

.Lifeline_add_event_button{
    background: #FFFFFF;
    color: #FFA825;
    border: none;
    padding: 10px 20px;
    border-radius: 24px;
    font-size: calc(14px * var(--fontScaler));
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

.Lifeline_add_event_button:hover{
    background: #F5F5F5;
}

.Lifeline_toggle_events_button{
    background: none;
    color: #8E9ABB;
    border: none;
    padding: 4px 0;
    font-size: calc(14px * var(--fontScaler));
    font-weight: 400;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.2s;
}

.Lifeline_toggle_events_button:hover{
    color: #6B7896;
}

.Lifeline_loading{
    text-align: center;
    color: #8E9ABB;
    padding: 40px 20px;
    font-size: calc(16px * var(--fontScaler));
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/lifeline/Lifeline.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;IAC9B,yDAAmE;IACnE,2BAA2B;IAC3B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,GAAG;AACH;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,yCAAyC;AAC7C","sourcesContent":[".Lifeline{  \n    /*background-color: #f9f9f9;*/\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 46px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n    display: flex;\n    flex-direction: column;\n}\n\n.Lifeline_form{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.Lifeline_header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    flex-shrink: 0;\n}\n\n.Lifeline_header_actions{\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.Lifeline_title{\n    font-weight: 600;\n    font-size: calc(20px * var(--fontScaler));\n    line-height: 27px;\n\n    color: #000000;\n}\n\n.Lifeline_main{\n    flex: 1;\n    overflow: hidden;\n}\n\n.Lifeline_events_container{\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n}\n\n.Lifeline_events_wrapper{\n    position: relative;\n    min-height: 100%;\n}\n\n.Lifeline_timeline_background{\n    position: absolute;\n    right: 28px;\n    top: 0;\n    bottom: 0;\n    min-height: 100%;\n    width: 57px;\n    background-size: 17px 20px;\n    background-position: right top;\n    background-image: url('../../../../assets/lifeline/line-point.svg');\n    background-repeat: repeat-y;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.Lifeline_events{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding-bottom: 20px;\n    padding-top: 20px;\n    margin-left: 16px;\n    position: relative;\n    z-index: 1;\n}\n\n/**/\n.Lifeline_item{\n    display: flex;\n    gap: 12px;\n}\n\n.Lifeline_item_sizer{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.Lifeline_item_sizer--negative{\n    align-items: flex-end;\n}\n\n.Lifeline_dots{\n    width: 57px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding-top: 20px;\n}\n\n.Lifeline_age{\n    font-weight: 600;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 16px;\n    color: #000000;\n    background: #f9f9f6;\n    padding: 2px 6px;\n    border-radius: 8px;\n    border: none;\n    position: relative;\n    z-index: 1;\n    white-space: nowrap;\n}\n\n.Lifeline_empty{\n    text-align: center;\n    color: #8E9ABB;\n    padding: 20px;\n    font-style: italic;\n}\n\n.error{\n    color: #E23424;\n    text-align: center;\n    padding: 20px;\n}\n\n.Lifeline_add_event_button{\n    background: #FFFFFF;\n    color: #FFA825;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 24px;\n    font-size: calc(14px * var(--fontScaler));\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.Lifeline_add_event_button:hover{\n    background: #F5F5F5;\n}\n\n.Lifeline_toggle_events_button{\n    background: none;\n    color: #8E9ABB;\n    border: none;\n    padding: 4px 0;\n    font-size: calc(14px * var(--fontScaler));\n    font-weight: 400;\n    cursor: pointer;\n    text-decoration: underline;\n    transition: color 0.2s;\n}\n\n.Lifeline_toggle_events_button:hover{\n    color: #6B7896;\n}\n\n.Lifeline_loading{\n    text-align: center;\n    color: #8E9ABB;\n    padding: 40px 20px;\n    font-size: calc(16px * var(--fontScaler));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
